// extracted by mini-css-extract-plugin
module.exports = {"root":"CancelAttendanceOrClass_root__3p429","cancelAttendanceButton":"CancelAttendanceOrClass_cancelAttendanceButton__2Vpqs"};